import BackgroundImage from 'components/ReusableComponents/BackgroundImage'
import LiteLoadingIndicator from 'components/ReusableComponents/LiteLoadingIndicator'
import FilePreview from 'components/ReusableComponents/Messaging/ConversationBubble/FilePreview'
import MediaGallery from 'components/ReusableComponents/Messaging/ConversationBubble/MediaGallery'
import {
  viewableFileExtensions,
  viewableImgExtensions,
  viewableVideoExtensions
} from 'features/Messaging/fileUploadConfig'
import { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import dashboardApi from 'services/api/dashboard'

import styles from './ConversationBubble.module.scss'

const supportedExtensions = [
  ...viewableImgExtensions,
  ...viewableFileExtensions,
  ...viewableVideoExtensions
]

function getExtension(fileName) {
  return fileName.match(/\.([a-zA-Z0-9]+)\?X-Amz/)?.[1]?.toLowerCase()
}

const ConversationMedia = ({
  mediaCount,
  messagingType,
  chatId,
  messageId,
  isSenderClient
}) => {
  const [inViewRef, isInView] = useInView({
    threshold: 1
  })

  const [isFetchingMedia, setIsFetchingMedia] = useState(false)
  const [fetchedMedia, setFetchedMedia] = useState()

  const [isMediaErred, setIsMediaErred] = useState(false)
  const [isMediaGalleryVisible, setIsMediaGalleryVisible] = useState(false)
  const [focusedMediaUrl, setFocusedMediaUrl] = useState()
  const [error, setError] = useState()

  useEffect(() => {
    if (
      isInView &&
      !fetchedMedia &&
      !isMediaErred &&
      mediaCount > 0 &&
      !isFetchingMedia
    ) {
      setIsFetchingMedia(true)
      dashboardApi
        .getChatMedia(chatId, messageId, messagingType)
        .then(media => {
          if (media.length === 0) {
            setIsMediaErred(true)
            setError('no media found')
            return
          }

          if (
            !media.every(m =>
              supportedExtensions.includes(getExtension(m.tempPublicPath))
            )
          ) {
            setIsMediaErred(true)
            setError('unsupported media type')
            return
          }
          setFetchedMedia(media)
          setIsMediaErred(false)
        })
        .catch(() => {
          setError('error during fetch')
          setIsMediaErred(true)
        })

      setIsFetchingMedia(false)
    }
  }, [
    isInView,
    chatId,
    messageId,
    messagingType,
    mediaCount,
    isFetchingMedia,
    fetchedMedia,
    isMediaErred
  ])

  function openGallery(url) {
    setIsMediaGalleryVisible(true)
    setFocusedMediaUrl(url)
  }

  if (isMediaErred) {
    return (
      <div
        ref={inViewRef}
        className={isSenderClient ? styles.mediaHolderClient : styles.mediaHolderAgent}
      >
        {[...Array(mediaCount)].map((_m, i) => (
          <div className={styles.mediaImg}>
            <BackgroundImage key={i} className={styles.mediaImgInner} title={error} />
          </div>
        ))}
      </div>
    )
  }

  if (mediaCount > 0 && !fetchedMedia) {
    return (
      <div
        ref={inViewRef}
        className={isSenderClient ? styles.mediaHolderClient : styles.mediaHolderAgent}
      >
        {[...Array(mediaCount)].map((_m, i) => (
          <div key={i} className={styles.mediaImg}>
            <div
              style={{
                opacity: 0.45,
                width: '100%',
                height: '100%',
                transform: 'scale(0.7)',
                transformOrigin: 'center center'
              }}
            >
              <LiteLoadingIndicator />
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (fetchedMedia) {
    return (
      <>
        <div
          ref={inViewRef}
          className={isSenderClient ? styles.mediaHolderClient : styles.mediaHolderAgent}
        >
          {fetchedMedia.map(m => (
            <FilePreview
              onClick={() => openGallery(m.tempPublicPath)}
              src={m.tempPublicPath}
              extension={getExtension(m.tempPublicPath)}
              showFileName
              key={m.tempPublicPath}
            />
          ))}
        </div>
        {isMediaGalleryVisible && (
          <MediaGallery
            onClose={() => setIsMediaGalleryVisible(false)}
            focusedMediaUrl={focusedMediaUrl}
            mediaList={fetchedMedia}
          />
        )}
      </>
    )
  }
  return null
}

export default ConversationMedia
